const {bind} = require('./lib/bind')
const TinyDatePicker = require('tiny-date-picker')

bind(document, 'DOMContentLoaded', function () {
  Array.from(document.querySelectorAll('.js-date-picker')).forEach((element) => {
    TinyDatePicker(element, {
      format(date) {
        const monthNames = [
          "Jan", "Feb", "Mar",
          "Apr", "May", "Jun", "Jul",
          "Aug", "Sep", "Oct",
          "Nov", "Dec"
        ];

        const day = date.getDate()
        const monthIndex = date.getMonth()
        const year = date.getFullYear()

        return `${monthNames[monthIndex]} ${day}, ${year}`
      },
      min: element.dataset.min,
    })
  })

  Array.from(document.querySelectorAll('.js-timezone-selector')).forEach((element) => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (element.options[element.selectedIndex].value == '') {
      const option = document.querySelector(`[data-tz-mapping*="${tz}"`)
      if (option) {
        option.parentElement.value = option.value
      }
    }
  })
})
